var app;
(function (app) {
    var support;
    (function (support) {
        var authorization;
        (function (authorization) {
            var AuthorizationService = /** @class */ (function () {
                /** @ngInject */
                function AuthorizationService(authService) {
                    this.authService = authService;
                }
                AuthorizationService.prototype.findPermission = function (idRecurso, context, readOnly) {
                    var _this = this;
                    if (readOnly === void 0) { readOnly = true; }
                    return this.userComponents().then(function (componentes) { return componentes.find(function (p) { return _this.comparePermission(p, context, [idRecurso], readOnly); }); });
                };
                /**
                 * Cria um gerenciador de permissões para o contexto especificado e para as permissões especificadas.
                 * Caso nenhuma permissão seja especificada, retorna um gerenciador de permissões para todas as permissões
                 * do contexto especificado.
                 *
                 * @param context
                 * @param idsRecursos
                 * @returns
                 */
                AuthorizationService.prototype.permissionManager = function (context) {
                    var _this = this;
                    var idsRecursos = [];
                    for (var _i = 1; _i < arguments.length; _i++) {
                        idsRecursos[_i - 1] = arguments[_i];
                    }
                    return this.userComponents().then(function (componentes) { return new authorization.PermissionManager(context, componentes.filter(function (p) { return _this.comparePermission(p, context, idsRecursos); })); });
                };
                /**
                 * Verifica se uma permissão especificada está presente na lista de permissões alvo e
                 * pertence ao contexto alvo.
                 *
                 * @param permission
                 * @param targetContext
                 * @param targetIdRecursos Se for vazio, verificará apenas se a permissão pertence ao contexto
                 * @returns
                 */
                AuthorizationService.prototype.comparePermission = function (permission, targetContext, targetIdRecursos, readOnly) {
                    if (readOnly === void 0) { readOnly = true; }
                    return permission.context === targetContext &&
                        (targetIdRecursos.length === 0 || targetIdRecursos.indexOf(permission.id) !== -1) &&
                        (readOnly || permission.readOnly === readOnly);
                };
                AuthorizationService.prototype.userComponents = function () {
                    return this.authService.getUser().then(function (user) { return user.componentes; });
                };
                return AuthorizationService;
            }());
            authorization.AuthorizationService = AuthorizationService;
            angular
                .module('app.support.authorization')
                .service('authorizationService', AuthorizationService);
        })(authorization = support.authorization || (support.authorization = {}));
    })(support = app.support || (app.support = {}));
})(app || (app = {}));
